import {Button, Card, Layout, Modal} from '@ui-kitten/components';
import React, {useEffect, useMemo, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {px, wp} from '../../../../../utils';
import {CheckboxList, TitleRow} from '../../../../components';

const FilterModal = ({visible, onClose, selectedKids, setSelectedKids}) => {
  const [selectedItems, setSelectedItems] = useState([...selectedKids]);
  const kids = useSelector((state) => state.general.kids);

  const studentsList = useMemo(
    () => kids.map(({id: value, name: text}) => ({text, value})),
    [kids],
  );

  useEffect(() => {
    setSelectedItems(
      selectedKids.map(({id: value, name: text}) => ({
        value,
        text,
      })),
    );
  }, [selectedKids]);

  const applyFilter = () => {
    setSelectedKids(
      selectedItems.map(({value: id, text: name}) => ({
        id,
        name,
      })),
    );
    onClose();
  };

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title="Select student(s)"
            type="primary"
            iconName="close-circle-outline"
            onIconClick={onClose}
            containerStyle={styles.title}
          />
          <ScrollView contentContainerStyle={styles.scrollView}>
            <CheckboxList
              list={studentsList}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
            />
          </ScrollView>
          <Button onPress={applyFilter} style={styles.submitButton}>
            {'Confirm selection'}
          </Button>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    height: px(380),
    width: wp(90),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  scrollView: {
    paddingBottom: px(17),
  },
  title: {
    width: '100%',
  },
  submitButton: {
    margin: px(17),
    marginTop: px(30),
  },
});

export default FilterModal;
